import React, { useEffect } from 'react';
import { Modal } from '@gerdau/hefesto';
import { ModalOverlay } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { useHistory } from 'react-router-dom';
import { getTaggingInformationScreen } from '../../../utils/Tagging';

export interface BlockedModalProps {
  onCloseModal: () => void;
}

export const BlockedModal = ({ onCloseModal }: BlockedModalProps) => {
  const { emitterId, receiverId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const { commerceScreenName = '' } = getTaggingInformationScreen(
    history.location.pathname
  );

  const handleBlockedModalTagging = () => {
    dispatch(
      sendTagging({
        event: 'emissor_bloqueado',
        screenName: commerceScreenName,
        etapa: 'selecionar_emissor_recebedor',
        select_emissor: emitterId ?? 'Inexistente',
        select_recebedor: receiverId,
        tipo_compra: localStorage.getItem('tipo_compra')
      })
    );
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    handleBlockedModalTagging();
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  return (
    <ModalOverlay>
      <Modal
        title="Emissor bloqueado"
        modalSize="sm"
        buttons={{
          right: {
            name: 'button-close-blocked-emitter',
            children: 'Fechar',
            onClick: onCloseModal,
            type: 'button'
          }
        }}
      >
        Entre em contato com o seu vendedor e informe o bloqueio.
      </Modal>
    </ModalOverlay>
  );
};
